var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeQuick3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7V17H24.5M32 17C32 18.9698 31.612 20.9204 30.8582 22.7403C30.1044 24.5601 28.9995 26.2137 27.6066 27.6066C26.2137 28.9995 24.5601 30.1044 22.7403 30.8582C20.9204 31.612 18.9698 32 17 32C15.0302 32 13.0796 31.612 11.2597 30.8582C9.43986 30.1044 7.78628 28.9995 6.3934 27.6066C5.00052 26.2137 3.89563 24.5601 3.14181 22.7403C2.38799 20.9204 2 18.9698 2 17C2 13.0218 3.58035 9.20644 6.3934 6.3934C9.20644 3.58035 13.0218 2 17 2C20.9782 2 24.7936 3.58035 27.6066 6.3934C30.4196 9.20644 32 13.0218 32 17Z",
    stroke: "#7900F8",
    strokeWidth: 2.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeQuick3);
export default __webpack_public_path__ + "static/media/home-quick-3.f0afbae942296e165891c112c7a2335d.svg";
export { ForwardRef as ReactComponent };